module.exports = __webpack_public_path__ + "static/img/successful.0234c46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shopping/successful.png
// module id = 9Vmt
// module chunks = 23